import { useCallback } from 'react';
import useCustomizeCarContext from '../useCustomizeCarContext';

export const useRemoveSelectedFeature = () => {
  const { toggleFeature } = useCustomizeCarContext();

  const removeSelectedFeature = useCallback(
    (code: string) => {
      toggleFeature(code);
    },
    [toggleFeature],
  );

  return { removeSelectedFeature };
};
